// extracted by mini-css-extract-plugin
export default {"notFound":"ExternalReports_notFound__eFrY0"};